import React, { memo } from 'react';
import Modal, { Styles, Props as ModalProps } from 'react-modal';
import './AlertModal.scss';
import CTAButton from '../CTAButton/CTAButton';

interface Props {
  isOpen: boolean;
  onRequestClose?: ModalProps['onRequestClose'];
  description: string;
  onConfirm: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
  onCancel?: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmDisabled?: boolean;
  cancelDisabled?: boolean;
  errorMessage?: string;
}

export const AlertModal = memo<Props>(
  ({
    isOpen,
    onRequestClose,
    description,
    confirmLabel = 'OK',
    cancelLabel = 'Cancel',
    onConfirm,
    onCancel,
    confirmDisabled,
    cancelDisabled,
    errorMessage,
  }) => {
    return (
      <Modal isOpen={isOpen} onRequestClose={onRequestClose} style={modalStyle}>
        <div className="AlertModal">
          <div className="AlertModal-content">
            <p className="AlertModal-content-description">{description}</p>
            {!!errorMessage && <p className="AlertModal-content-errorMessage">{errorMessage}</p>}
          </div>
          <div className="AlertModal-buttonsRow">
            {onCancel && <CTAButton text={cancelLabel} onClick={onCancel} disabled={cancelDisabled} invert />}
            <CTAButton text={confirmLabel} onClick={onConfirm} disabled={confirmDisabled} />
          </div>
        </div>
      </Modal>
    );
  },
);

AlertModal.displayName = 'AlertModal';

export default AlertModal;

const modalStyle: Styles = {
  content: { width: 600, height: 200, borderRadius: 20, margin: 'auto', padding: '1rem' },
  overlay: { zIndex: 20, backgroundColor: 'rgba(0, 0, 0, 0.5)' },
};
